import { Form } from "@circle-react-uikit/Form";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

import { t } from "@/i18n-js/instance";

export const RejectWithReasonTextArea = ({
  i18nRoot,
  onReasonChange,
}: {
  i18nRoot: string;
  onReasonChange: (reason: string) => void;
}) => {
  const { watch } = useFormContext();
  const reason = watch("reason");

  useEffect(() => {
    onReasonChange(reason);
  }, [reason, onReasonChange]);

  return (
    <Form.TextArea
      autoFocus
      name="reason"
      className="mt-2 w-full"
      rows={3}
      placeholder={t([i18nRoot, "rejection_note_placeholder"])}
    />
  );
};
